import { useState } from 'react';
import { useLang } from 'hooks/lang';

import { DropdownMenu, DropdownMenuItem } from 'components/Blocks';

import { BookOpenIcon } from 'components/Icons';

import { InvoiceLogsModal } from './LogsModal';
import { CancelProjectInvoiceOption } from './Cancel';

export function InvoiceControlMenu() {
  const { t } = useLang();

  const [openedModal, setOpenedModal] = useState<string | null>(null);

  return (
    <>
      <InvoiceLogsModal isOpen={openedModal === 'LOGS'} close={() => setOpenedModal(null)} />

      <DropdownMenu align="end">
        <DropdownMenuItem onClick={() => setOpenedModal('LOGS')}>
          <BookOpenIcon />
          {t('logs')}
        </DropdownMenuItem>

        <CancelProjectInvoiceOption />
      </DropdownMenu>
    </>
  );
}
